class SgcGridBlock {
  run() {
    /* PORTFOLIO MODEL */
    for (const el of document.getElementsByClassName("list-block")) {
      const skillsEntries = el.children[0].children;
      let visibleMobile = skillsEntries.length > 3 ? 3 : skillsEntries;

      const loadMore = el.children[1];

      if (loadMore) {
        loadMore.addEventListener("click", () => {
          loadMore.style.opacity = 0;

          for (let i = 0; i < skillsEntries.length; i++) {
            if (!skillsEntries[visibleMobile + i]) break;

            skillsEntries[visibleMobile + i].style.position = "relative";
            skillsEntries[visibleMobile + i].style.opacity = 1;

            skillsEntries[visibleMobile + i].animate(
              [
                // keyframes
                {
                  transform: `translateY(-${
                    skillsEntries[visibleMobile + i].offsetHeight * (i + 1)
                  }px)`,
                },
                { transform: "translateY(0px)" },
              ],
              {
                // timing options
                duration: 300,
                iterations: 1,
                easing: "ease-in-out",
              }
            );
          }
        });
      }
    }

    /* PORTFOLIO LINE ANIMATION */
    const options = {
      root: null,
      rootMargin: "-150px 0px",
      threshold: this.generateThresholdSteps(),
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        const el = entry.target;

        console.log(el);

        el.children[1].style.transform = `scaleX(${entry.intersectionRatio})`;

        // console.log(entry.intersectionRatio);

        if (entry.intersectionRatio >= 0.98) {
          el.children[1].style.transform = `scaleX(1)`;
          observer.unobserve(entry.target);
        }
      });
    }, options);

    const portfolioCols = document.getElementsByClassName("portfolio-col");
    let index = portfolioCols.length;
    for (const el of portfolioCols) {
      index--;

      el.style.zIndex = `${index}`;

      observer.observe(el);
    }
  }

  generateThresholdSteps() {
    const res = [];

    const stepSize = 0.01;

    for (let i = 0; i < 1; i += stepSize) {
      res.push(i);
    }

    res.push(1);

    return res;
  }

  makeEaseInOut(timing) {
    return function (timeFraction) {
      if (timeFraction < 0.5) return timing(2 * timeFraction) / 2;
      else return (2 - timing(2 * (1 - timeFraction))) / 2;
    };
  }
}

module.exports = SgcGridBlock;
